import * as React from "react";
import {COVER_TYPES, floatingNavButton, getEventForProduct, productCard} from "insurance/utils";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {handleNavigation, RoutePaths} from "insurance/routes";
import {logBranchEvent} from "analytics/branch";
import {saveSelectedSubProduct, saveSelectedCoverType} from "insurance/actions";
import {useEffect} from "react";
import {AndroidApis} from "app";
import {productViewedEvent} from "insurance/events";
import ProductCard from "./productCard";
interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    isAndroid: boolean;
    subCategories: object;
}

function CategoryList(props: IConnectProps) {
    const subCategory = props.subCategories;
    useEffect(() => {
        if (props.isAndroid) {
            AndroidApis.clearWebStack();
        }
    }, []);
    const renderProduct = Object.keys(subCategory).map((key) => {
        return{
            heading: subCategory[key].title,
            price: subCategory[key].productPrice,
            description: "",
            icon: subCategory[key].icon,
            handleClick: handleProceed,
            routeName: RoutePaths.PRODUCT_LIST,
            identifier: key,
            productCoverTypes: subCategory[key].productCoverTypes,
        };
    });
    function handleProceed(routePath: string, productName: string, covertType: string) {
        if (routePath === RoutePaths.PRODUCT_LIST) {
            if (props.userId) {
                logBranchEvent(getEventForProduct(productName), {userId: props.userId});
                productViewedEvent(getEventForProduct(productName));
            }
            if (covertType) { props.dispatch(saveSelectedCoverType(covertType === COVER_TYPES.INDIVIDUAL)); }
            if (productName) { props.dispatch(saveSelectedSubProduct(productName)); }
            handleNavigation(routePath);
        }
    }
    return(
        <div style={{height: "100vh", marginTop: "20px", width: "100%"}}>
            {floatingNavButton({label: "My Insurances", routeTo: RoutePaths.ACTIVE_INSURANCES})}
            <ProductCard listOfProducts={renderProduct}/>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth ? state.login.auth.userId : null,
        isAndroid: state.login.isAndroid,
        subCategories: state.insurance.subProduct,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(CategoryList);
